// 用于持久化数据
import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import global from './constantStore'

// 用于持久数据
export const Devices = {
  namespaced: true,
  state: {
    all: {}, // 用户ID绑定的设备id列表，若非本人设备，需要退出
  },
  getters: {
    list (state) {
      const list = state.all[global.userId] || []
      return [...list]
    },
    isMy (state) {
      const list = state.all[global.userId] || []
      return list.includes(global.fromSpace)
    },
    all (state) {
      // 所有的设备id的合集
      const list = Object.keys(state.all).map(v => state.all[v]).reduce((pre, v) => [...pre, ...v], [])
      return list
    },
    isUsed (state, getters) {
      // 该id是否被绑定过
      return getters.all.includes(global.fromSpace)
    },
  },
  mutations: {
    set (state, id) {
      const uid = global.userId
      if (!state.all[uid]) {
        state.all[uid] = []
      }
      if (state.all[uid].includes(id)) return
      state.all[uid].push(id)
    },
    remove (state, id) {
      const uid = global.userId
      state.all[uid] = state.all[uid].filter(v => v !== id)
    },
    clear (state) {
      const uid = global.userId
      state.all[uid] = []
    },
  },
}

export const Users = {
  namespaced: true,
  state: {
    all: {},
  },
  getters: {
    info (state) {
      const uid = global.userId
      return state.all[uid]
    },
  },
  mutations: {
    set (state, user) {
      const uid = global.userId
      state.all[uid] = user
    },
  },
}

let Persist = (store) => {
  store.subscribe((mutation, state) => {})
}
if (!localStorage) {
  Persist = createPersistedState({
    paths: ['Devices', 'Users'],
  })
}
export const PersistPlugin = Persist


